import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as s, normalizeClass as n, createElementVNode as r } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconHubspot",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, l, f, _, a) {
  return d(), s("svg", {
    "aria-label": l.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--hubspot"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Hubspot",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    r("rect", {
      x: "2",
      y: "2",
      width: "20",
      height: "20",
      rx: "2",
      fill: "#E77C39"
    }, null, -1),
    r("path", {
      d: "M6.6 4a1.6 1.6 0 1 0 .853 2.951l4.79 3.61a3.821 3.821 0 0 0-.843 2.399c0 .993.38 1.895.999 2.576l-1.949 1.949a1.28 1.28 0 1 0 .905.905l2.054-2.054h.001a3.84 3.84 0 0 0 5.67-3.376 3.838 3.838 0 0 0-3.2-3.783v-2.15a1.28 1.28 0 1 0-1.418-2.122 1.28 1.28 0 0 0 .138 2.122v2.15a3.812 3.812 0 0 0-1.376.52L8.172 5.891A1.6 1.6 0 0 0 6.6 4Zm8.64 7.04c1.059 0 1.92.861 1.92 1.92s-.861 1.92-1.92 1.92a1.922 1.922 0 0 1-1.92-1.92c0-1.059.861-1.92 1.92-1.92Z",
      fill: "#fff"
    }, null, -1)
  ])], 10, m);
}
const g = /* @__PURE__ */ o(c, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=hubspot.js.map
